<template>
    <div class='content'>
        <div class="contentItem">
            <h3 class="f28 bold">
                <span>小伙伴正在拼团，可参与拼团</span>
                <img src='/images/public/more.png' align="middle" @click='show=true' v-if='list.length > 2'>
            </h3>
            <div class='teamItem' v-for='(item,index) in showList' :key='index'>
                <div class='left'>
                    <img v-if='item.groupHeaderImage' :src='item.groupHeaderImage | formatImgUrl(200,200,true)' align="middle">
                    <img v-else :src='DEFAULT_AVATAR' align="middle">
                    
                    <div>{{item.groupHeaderNickName}}</div>
                </div>

        
                <div class='right'>
                    <div class='suc'>还差{{item.differMemberNum}}人成功</div>
                    <button class='primary mybtn' @click='toSubmit(item.id)'>去参团</button>
                </div>
                
            </div>
         
        </div>


        <van-popup position="bottom" v-model="show" overlay-class='layer'>
            <div class="containerExpree f28">
                <div class="title">正在拼团</div>
                <div class="close" @click="show = false"></div>
                <div class='content_team'>

                    <div class='teamItem' v-for='(item,index) in list' :key='index'>
                        <div class='left'>
                            <img v-if='item.groupHeaderImage' :src='item.groupHeaderImage | formatImgUrl(200,200,true)' align="middle">
                            <img v-else :src='DEFAULT_AVATAR' align="middle">
                            <div>{{item.groupHeaderNickName}}</div>
                        </div>
                        <div class='right'>
                            <div class='suc'>还差{{item.differMemberNum}}人成功</div>
                            <button class='primary mybtn' @click='toSubmit(item.id)'>去参团</button>
                        </div>
                        
                    </div>
      
                </div>
            </div>
        </van-popup>
        
    </div>
</template>

<script>
    import homeApi from '@/axios/home'
    import zhugeObj from '@/assets/js/track'
    import publicObj from '@/assets/js/public';
    import { Dialog } from 'vant';
    export default {
        name: 'teamInfo',
        props: {
            team : {
                type : Object,
                default : ()=>{
                    return {
                        groupActivityBo : {}
                    }
                }
            },
        },
        data () {
            return {
                show : false,
                list : [],
                showList : [],
                inter : ''
            }
        },
        watch: {
            team (val) {
                this.getList();
            }
        },
        computed: {},
        created () {
           
            this.getList();
            if(this.team.groupActivityBo.isShowGroup){
                this.inter = setInterval(()=>{
                    this.getList();
                },3000)
            }
            
        },
        mounted () {

        },
        methods: {
            formatImgUrl(url, width, height,m_fill) {
                let surl = url;
                if (url) {
                        url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
                        // url = url.replace(',jpg', ",webp");
                        if(url != surl){
                            url +=',q_80';
                        }
                        
                        
                    if(m_fill){
                        // console.log(m_fill)
                        url = url.replace('m_lfit', "m_fill");
                    }
                }
                return url
            },
            toSubmit(id){

                let params1 = {
                    action : 'normal'
                }
                params1.curingServiceId = this.team.id;
                params1.buyQuantity = 1;
                
                params1.groupRecordId = id;
                
        
                // let tag = await publicObj.validationTeam(params1);
                // console.log(tag)
                // if(!tag){
                //     return;
                // }
                zhugeObj.track({
                    title : '服务详情-去参团',
                    content : {
                        '去参团' : id
                    }
                })

                homeApi.getShoppingCart(params1).then((res)=>{
                    
                    this.$router.push({name:'homeBag',query:{curingServiceId:this.team.id,buyQuantity:1,teamId:id}});
                }).catch((res)=>{
                    if(res.code == '110001'){
                        delete params1.groupRecordId;
                        homeApi.getShoppingCart(params1).then((data)=>{
                            Dialog.alert({
                                title:'温馨提示',
                                message: res.message,
                                closeOnClickOverlay : true
                            }).then(() => {

                                this.$router.push({name:'homeBag',query:{curingServiceId:this.team.id,buyQuantity:1,isTeam:1}});
                            });
                        })
                       
                    }
                })
                
                //点击了去参团
        

            
                // this.$router.push({name:'homeBag',query:{curingServiceId:this.team.id,buyQuantity:1,teamId:id}})
            },
            getList(){
                if(!this.team.groupActivityBo.id){
                    return;
                }
                homeApi.groupActivityList(this.team.groupActivityBo.id).then((res)=>{
                    if(res.length != 0){
                        this.list = res;
                    }else{
                        this.$emit('nolist');
                    }
                    this.showList = [];
                    if(this.list[0]){
                        this.showList.push(this.list[0])
                    }
                    if(this.list[1]){
                        this.showList.push(this.list[1])
                    }
                })
            }
        },
        beforeDestroy(){
            clearInterval(this.inter);
            this.inter = null;
        }
    }
</script>

<style lang="scss" scoped>
    .containerExpree{
       
        padding: 30px;
        position: relative;
        .content_team{
           height: 500px;
           margin-bottom: 30px;
           overflow: scroll;
        }
        .title{
            line-height: 40px;
            margin-bottom: 40px;
            font-size:32px; 
        }
        .close{
            width: 36px;
            height: 36px;
            position: absolute;
            top: 30px;
            right: 30px;
            background: url("/images/public/close.png") no-repeat center;
            background-size: 32px;
        }
    }
    .content{
        // padding:32px;
        border-bottom:20px #F6F6F6 solid;
    }
    .contentItem{
        padding: 40px 40px 40px;
        line-height: 40px;
        h3{
            margin-bottom: 32px;
            line-height: 40px;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &::after{
                content: '';
                width: 8px;
                height: 24px;
                background: $primary-color;
                position: absolute;
                left: -12px;
                top:6px
            }
            img{
                width: 40px;
                height: 12px;
            }
        }
    }
    .teamItem{
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
        .left{
            display: flex;
            div{
                line-height: 88px;
                font-size: 28px;
                color:#333;
                font-weight:500;
                margin-left: 24px;
                width: 200px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
        
        }
        .mybtn{
            height: 52px;
            line-height: 52px;
            background:rgba(106,160,164,1);
            font-size: 24px;
            min-width: 144px;
            margin-left:16px;
        }
        .right{
            display: flex;
            .suc{
                color:#BBBBBB;
                line-height: 82px;
                font-size: 24px;
                font-weight:400;
            }
            align-items: center;
        
        }
        img{
            width: 84px;
            height: 84px;
            border-radius:50%; 
            // box-sizing: border-box;
            border: 4px solid #6AA0A4;
        }
    }

</style>
